<template>
  <div>
    <el-button
      size="mini"
      v-for="(item, index) in getBaseBtns"
      :key="index"
      :disabled="!item.access"
      @click.native="eventTrigger(item, row)"
      >{{ item.name }}</el-button
    >
    <el-dropdown class="ml-10px" v-if="getMoreBtns.length">
      <el-button size="mini">
        更多<i class="iconfont icon-line-right text-12px"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(item, index) in getMoreBtns"
          :key="index"
          :disabled="!item.access"
          @click.native="eventTrigger(item, row)"
          >{{ item.name }}</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "wiz-table-buttons",
  props: {
    displayForm: {
      // disabled || hidden, 默认hidden
      type: String,
      default: "hidden",
    },
    showMoreBtn: {
      // 是否显示更多
      type: Boolean,
      default: true,
    },
    accessButtons: {
      // 所有的按钮数据
      type: Array,
      default: () => [],
    },
    row: {
      // 表格行内数据
      type: Object,
      default: () => {},
    },
    hasAccess: {
      // 判断路由权限
      type: Function,
      default: () => true,
    },
    displayBtnsCount: {
      // 有 “更多” 按钮时，每行最大显示按钮数量
      type: Number,
      default: 4,
    },
  },
  computed: {
    // 返回有初始操作权限的按钮
    operateAccessBtns() {
      return this.accessButtons.map((item) => {
        if (!item.hasOwnProperty("access")) {
          item.access = true;
        }
        item.access = item.access && this.hasAccess(item.operateName);
        return item;
      });
    },
    // 获取基础需要展示的按钮
    getBaseBtns() {
      let baseBtns = this.operateAccessBtns;
      if (this.displayForm === "hidden") {
        baseBtns = this.operateAccessBtns.filter((item) => item.access);
        if (baseBtns.length > this.displayBtnsCount && this.showMoreBtn) {
          baseBtns = baseBtns.slice(0, this.displayBtnsCount - 1);
        }
      } else if (
        this.displayForm === "disabled" &&
        baseBtns.length > this.displayBtnsCount &&
        this.showMoreBtn
      ) {
        baseBtns = baseBtns.slice(0, this.displayBtnsCount - 1);
      }
      return baseBtns;
    },
    // 获取更多按钮
    getMoreBtns() {
      let moreBtns = [];
      if (this.showMoreBtn && this.displayForm === "hidden") {
        const allAccessBtns = this.operateAccessBtns.filter(
          (item) => item.access
        );
        if (allAccessBtns.length > this.displayBtnsCount) {
          moreBtns = allAccessBtns.slice(this.displayBtnsCount - 1);
        }
      } else if (
        this.showMoreBtn &&
        this.displayForm === "disabled" &&
        this.operateAccessBtns.length > this.displayBtnsCount
      ) {
        moreBtns = this.operateAccessBtns.slice(this.displayBtnsCount - 1);
      }
      return moreBtns;
    },
  },
  data() {
    return {};
  },
  methods: {
    // 按钮点击
    eventTrigger(buttonInfo, row) {
      this.$emit("eventTrigger", buttonInfo, row);
    },
  },
};
</script>

<style lang="scss" scoped></style>
